import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer } from '../hooks/useScrollAnimation';
import { useCountUp } from '../hooks/useCountUp';
interface AchievementCardProps {
  end: number;
  suffix?: string;
  prefix?: string;
  label: string;
  description: string;
  glowColor?: 'cyan' | 'gold';
  decimals?: number;
}
function AchievementCard({
  end,
  suffix = '',
  prefix = '',
  label,
  description,
  glowColor = 'cyan',
  decimals = 0
}: AchievementCardProps) {
  const {
    value,
    ref
  } = useCountUp({
    end,
    suffix,
    prefix,
    decimals
  });
  return <motion.div variants={fadeInUp} className="p-8 border-l-2 border-gold/40 pl-8" data-id="element-61">
      <div ref={ref} className="text-5xl md:text-6xl font-bold text-gold mb-3 tracking-tight" data-id="element-62">
        {value}
      </div>
      <h3 className="text-white font-semibold text-lg mb-2" data-id="element-63">{label}</h3>
      <p className="text-slate-400 text-sm leading-relaxed" data-id="element-64">{description}</p>
    </motion.div>;
}
export function AchievementsSection() {
  return <section id="achievements" className="py-20 md:py-32 bg-dark-bg relative border-t border-dark-border/30" data-id="element-65">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-66">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={staggerContainer} data-id="element-67">
          <motion.div variants={fadeInUp} className="mb-16" data-id="element-68">
            <span className="font-sans text-gold/80 tracking-widest uppercase text-xs font-semibold mb-2 block" data-id="element-69">
              Signature Achievements
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-70">
              Impact at Scale
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0 divide-y sm:divide-y-0 sm:divide-x divide-dark-border/50" data-id="element-71">
            <AchievementCard end={1.2} prefix="$" suffix="B" decimals={1} label="Technology Portfolio" description="Annual infrastructure and assets managed" data-id="element-72" />
            <AchievementCard end={1700} suffix="+" label="Engineers Led" description="Global team across 12 countries and 4 continents" data-id="element-73" />
            <AchievementCard end={140} prefix="$" suffix="M" label="Annual Cost Savings" description="Through cloud optimization and vendor consolidation" glowColor="gold" data-id="element-74" />
            <AchievementCard end={50000} label="VMs Migrated" description="On-premise to hybrid cloud per year" data-id="element-75" />
          </div>
        </motion.div>
      </div>
    </section>;
}